/*!
 * Copyright (c) 2018 Digital Bazaar, Inc. All rights reserved.
 */
'use strict';

var _toConsumableArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _defineProperty = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _objectSpread = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var constants = require('./constants');

var jsonld = require('jsonld');

var _require = require('./documentLoader'),
    extendContextLoader = _require.extendContextLoader,
    strictDocumentLoader = _require.strictDocumentLoader;

var _require2 = require('serialize-error'),
    serializeError = _require2.serializeError;

var strictExpansionMap = require('./expansionMap');

var PublicKeyProofPurpose = require('./purposes/PublicKeyProofPurpose');

module.exports = /*#__PURE__*/function () {
  function ProofSet() {
    _classCallCheck(this, ProofSet);
  }

  _createClass(ProofSet, [{
    key: "add",

    /**
     * Adds a Linked Data proof to a document. If the document contains other
     * proofs, the new proof will be appended to the existing set of proofs.
     *
     * Important note: This method assumes that the term `proof` in the given
     * document has the same definition as the `https://w3id.org/security/v2`
     * JSON-LD @context.
     *
     * @param document {object|string} Object to be signed, either a string URL
     *   (resolved via the given `documentLoader`) or a plain object (JSON-LD
     *   document).
     * @param options {object} Options hashmap.
     *
     * A `suite` option is required:
     *
     * @param options.suite {LinkedDataSignature} a signature suite instance
     *   that will create the proof.
     *
     * A `purpose` option is required:
     *
     * @param options.purpose {ProofPurpose} a proof purpose instance that will
     *   augment the proof with information describing its intended purpose.
     *
     * Advanced optional parameters and overrides:
     *
     * @param [documentLoader] {function} a custom document loader,
     *   `Promise<RemoteDocument> documentLoader(url)`.
     * @param [expansionMap] {function} A custom expansion map that is
     *   passed to the JSON-LD processor; by default a function that will throw
     *   an error when unmapped properties are detected in the input, use `false`
     *   to turn this off and allow unmapped properties to be dropped or use a
     *   custom function.
     * @param [compactProof] {boolean} `true` instructs this call to compact
     *   the resulting proof to the same JSON-LD `@context` as the input
     *   document; this is the default behavior. Setting this flag to `false` can
     *   be used as an optimization to prevent an unnecessary compaction when the
     *   caller knows that all used proof terms have the same definition in the
     *   document's `@context` as the `constants.SECURITY_CONTEXT_URL` `@context`.
     *
     * @return {Promise<object>} resolves with the signed document, with
     *   the signature in the top-level `proof` property.
     */
    value: function () {
      var _add = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(document) {
        var _ref,
            suite,
            purpose,
            documentLoader,
            expansionMap,
            _ref$compactProof,
            compactProof,
            input,
            proofProperty,
            proof,
            expandedProof,
            _yield$_getTypeInfo,
            types,
            alias,
            ctx,
            _compactProof,
            key,
            _args = arguments;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _ref = _args.length > 1 && _args[1] !== undefined ? _args[1] : {}, suite = _ref.suite, purpose = _ref.purpose, documentLoader = _ref.documentLoader, expansionMap = _ref.expansionMap, _ref$compactProof = _ref.compactProof, compactProof = _ref$compactProof === void 0 ? true : _ref$compactProof;

                if (suite) {
                  _context.next = 3;
                  break;
                }

                throw new TypeError('"options.suite" is required.');

              case 3:
                if (purpose) {
                  _context.next = 5;
                  break;
                }

                throw new TypeError('"options.purpose" is required.');

              case 5:
                if (!suite.legacy) {
                  _context.next = 8;
                  break;
                }

                if (purpose instanceof PublicKeyProofPurpose) {
                  _context.next = 8;
                  break;
                }

                throw new TypeError("The \"".concat(suite.type, "\" suite requires \"options.purpose\" to be ") + 'an instance of "PublicKeyProofPurpose".');

              case 8:
                if (documentLoader) {
                  documentLoader = extendContextLoader(documentLoader);
                } else {
                  documentLoader = strictDocumentLoader;
                }

                if (expansionMap !== false) {
                  expansionMap = strictExpansionMap;
                }

                if (!(typeof document === 'string')) {
                  _context.next = 14;
                  break;
                }

                _context.next = 13;
                return documentLoader(document);

              case 13:
                document = _context.sent;

              case 14:
                if (!compactProof) {
                  _context.next = 20;
                  break;
                }

                _context.next = 17;
                return jsonld.compact(document, constants.SECURITY_CONTEXT_URL, {
                  documentLoader: documentLoader,
                  expansionMap: expansionMap,
                  compactToRelative: false
                });

              case 17:
                input = _context.sent;
                _context.next = 21;
                break;

              case 20:
                // TODO: optimize to modify document in place to maximize optimization
                // shallow copy document to allow removal of existing proofs
                input = _objectSpread({}, document);

              case 21:
                // save but exclude any existing proof(s)
                proofProperty = suite.legacy ? 'signature' : 'proof'; //const existingProofs = input[proofProperty];

                delete input[proofProperty]; // create the new proof (suites MUST output a proof using the security-v2
                // `@context`)

                _context.next = 25;
                return suite.createProof({
                  document: input,
                  purpose: purpose,
                  documentLoader: documentLoader,
                  expansionMap: expansionMap,
                  compactProof: compactProof
                });

              case 25:
                proof = _context.sent;

                if (!compactProof) {
                  _context.next = 44;
                  break;
                }

                // compact proof to match document's context
                if (suite.legacy) {
                  expandedProof = _defineProperty({}, constants.SECURITY_SIGNATURE_URL, proof);
                } else {
                  expandedProof = _defineProperty({}, constants.SECURITY_PROOF_URL, {
                    '@graph': proof
                  });
                } // account for type-scoped `proof` definition by getting document types


                _context.next = 30;
                return _getTypeInfo({
                  document: document,
                  documentLoader: documentLoader,
                  expansionMap: expansionMap
                });

              case 30:
                _yield$_getTypeInfo = _context.sent;
                types = _yield$_getTypeInfo.types;
                alias = _yield$_getTypeInfo.alias;
                expandedProof['@type'] = types;
                ctx = jsonld.getValues(document, '@context');
                _context.next = 37;
                return jsonld.compact(expandedProof, ctx, {
                  documentLoader: documentLoader,
                  expansionMap: expansionMap,
                  compactToRelative: false
                });

              case 37:
                _compactProof = _context.sent;
                delete _compactProof[alias];
                delete _compactProof['@context']; // add proof to document

                key = Object.keys(_compactProof)[0];
                jsonld.addValue(document, key, _compactProof[key]);
                _context.next = 46;
                break;

              case 44:
                // in-place restore any existing proofs

                /*if(existingProofs) {
                  document[proofProperty] = existingProofs;
                }*/
                // add new proof
                delete proof['@context'];
                jsonld.addValue(document, proofProperty, proof);

              case 46:
                return _context.abrupt("return", document);

              case 47:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function add(_x) {
        return _add.apply(this, arguments);
      }

      return add;
    }()
    /**
     * Verifies Linked Data proof(s) on a document. The proofs to be verified
     * must match the given proof purpose.
     *
     * Important note: This method assumes that the term `proof` in the given
     * document has the same definition as the `https://w3id.org/security/v2`
     * JSON-LD @context.
     *
     * @param {object|string} document - Object with one or more proofs to be
     *   verified, either a string URL (resolved to an object via the given
     *   `documentLoader`) or a plain object (JSON-LD document).
     *
     * @param {LinkedDataSignature|LinkedDataSignature[]} suite -
     *   Acceptable signature suite instances for verifying the proof(s).
     *
     * @param {ProofPurpose} purpose - A proof purpose instance that will
     *   match proofs to be verified and ensure they were created according to
     *   the appropriate purpose.
     *
     * Advanced optional parameters and overrides:
     *
     * @param {function} [documentLoader]  a custom document loader,
     *   `Promise<RemoteDocument> documentLoader(url)`.
     * @param {function} [expansionMap] - A custom expansion map that is
     *   passed to the JSON-LD processor; by default a function that will throw
     *   an error when unmapped properties are detected in the input, use `false`
     *   to turn this off and allow unmapped properties to be dropped or use a
     *   custom function.
     * @param {boolean} [compactProof=true] - Indicates that this method cannot
     *   assume that the incoming document has defined all proof terms in the
     *   same way as the `constants.SECURITY_CONTEXT_URL` JSON-LD `@context`.
     *   This means that this method must compact any found proofs to this
     *   context for internal and extension processing; this is the default
     *   behavior. To override this behavior and optimize away this step because
     *   the caller knows that the input document's JSON-LD `@context` defines
     *   the proof terms in the same way, set this flag to `false`.
     *
     * @return {Promise<{verified: boolean, results: Array, error: *}>} resolves
     *   with an object with a `verified`boolean property that is `true` if at
     *   least one proof matching the given purpose and suite verifies and `false`
     *   otherwise; a `results` property with an array of detailed results;
     *   if `false` an `error` property will be present.
     */

  }, {
    key: "verify",
    value: function () {
      var _verify2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(document) {
        var _ref2,
            suite,
            purpose,
            documentLoader,
            expansionMap,
            _ref2$compactProof,
            compactProof,
            suites,
            legacy,
            _yield$_getProofs,
            proofSet,
            doc,
            results,
            verified,
            _ref3,
            errors,
            result,
            _args2 = arguments;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _ref2 = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {}, suite = _ref2.suite, purpose = _ref2.purpose, documentLoader = _ref2.documentLoader, expansionMap = _ref2.expansionMap, _ref2$compactProof = _ref2.compactProof, compactProof = _ref2$compactProof === void 0 ? true : _ref2$compactProof;

                if (suite) {
                  _context2.next = 3;
                  break;
                }

                throw new TypeError('"options.suite" is required.');

              case 3:
                if (purpose) {
                  _context2.next = 5;
                  break;
                }

                throw new TypeError('"options.purpose" is required.');

              case 5:
                suites = Array.isArray(suite) ? suite : [suite];

                if (!(suites.length === 0)) {
                  _context2.next = 8;
                  break;
                }

                throw new TypeError('At least one suite is required.');

              case 8:
                legacy = suites.some(function (s) {
                  return s.legacy;
                });

                if (!legacy) {
                  _context2.next = 16;
                  break;
                }

                if (!suites.some(function (s) {
                  return !s.legacy;
                })) {
                  _context2.next = 14;
                  break;
                }

                throw new Error('Legacy suites may not be combined with current suites.');

              case 14:
                if (purpose instanceof PublicKeyProofPurpose) {
                  _context2.next = 16;
                  break;
                }

                throw new TypeError('"options.purpose" must be an instance of "PublicKeyProofPurpose"' + 'to use a legacy suite.');

              case 16:
                if (documentLoader) {
                  documentLoader = extendContextLoader(documentLoader);
                } else {
                  documentLoader = strictDocumentLoader;
                }

                if (expansionMap !== false) {
                  expansionMap = strictExpansionMap;
                }

                _context2.prev = 18;

                if (!(typeof document === 'string')) {
                  _context2.next = 25;
                  break;
                }

                _context2.next = 22;
                return documentLoader(document);

              case 22:
                document = _context2.sent;
                _context2.next = 26;
                break;

              case 25:
                // TODO: consider in-place editing to optimize when `compactProof`
                // is `false`
                // shallow copy to allow for removal of proof set prior to canonize
                document = _objectSpread({}, document);

              case 26:
                _context2.next = 28;
                return _getProofs({
                  document: document,
                  legacy: legacy,
                  documentLoader: documentLoader,
                  expansionMap: expansionMap,
                  compactProof: compactProof
                });

              case 28:
                _yield$_getProofs = _context2.sent;
                proofSet = _yield$_getProofs.proofSet;
                doc = _yield$_getProofs.document;
                document = doc; // verify proofs

                _context2.next = 34;
                return _verify({
                  document: document,
                  suites: suites,
                  proofSet: proofSet,
                  purpose: purpose,
                  documentLoader: documentLoader,
                  expansionMap: expansionMap,
                  compactProof: compactProof
                });

              case 34:
                results = _context2.sent;

                if (!(results.length === 0)) {
                  _context2.next = 37;
                  break;
                }

                throw new Error('Could not verify any proofs; no proofs matched the required ' + 'suite and purpose.');

              case 37:
                // combine results
                verified = results.some(function (r) {
                  return r.verified;
                });

                if (verified) {
                  _context2.next = 43;
                  break;
                }

                errors = (_ref3 = []).concat.apply(_ref3, _toConsumableArray(results.filter(function (r) {
                  return r.error;
                }).map(function (r) {
                  return r.error;
                })));
                result = {
                  verified: verified,
                  results: results
                };

                if (errors.length > 0) {
                  result.error = errors;
                }

                return _context2.abrupt("return", result);

              case 43:
                return _context2.abrupt("return", {
                  verified: verified,
                  results: results
                });

              case 46:
                _context2.prev = 46;
                _context2.t0 = _context2["catch"](18);

                _addToJSON(_context2.t0);

                return _context2.abrupt("return", {
                  verified: false,
                  error: _context2.t0
                });

              case 50:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[18, 46]]);
      }));

      function verify(_x2) {
        return _verify2.apply(this, arguments);
      }

      return verify;
    }()
  }]);

  return ProofSet;
}();

function _getProofs(_x3) {
  return _getProofs2.apply(this, arguments);
}

function _getProofs2() {
  _getProofs2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref4) {
    var document, legacy, documentLoader, expansionMap, compactProof, proofProperty, proofSet;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            document = _ref4.document, legacy = _ref4.legacy, documentLoader = _ref4.documentLoader, expansionMap = _ref4.expansionMap, compactProof = _ref4.compactProof;
            // handle document preprocessing to find proofs
            proofProperty = legacy ? 'signature' : 'proof';

            if (!compactProof) {
              _context3.next = 6;
              break;
            }

            _context3.next = 5;
            return jsonld.compact(document, constants.SECURITY_CONTEXT_URL, {
              documentLoader: documentLoader,
              expansionMap: expansionMap,
              compactToRelative: false
            });

          case 5:
            document = _context3.sent;

          case 6:
            proofSet = jsonld.getValues(document, proofProperty);
            delete document[proofProperty];

            if (!(proofSet.length === 0)) {
              _context3.next = 10;
              break;
            }

            throw new Error('No matching proofs found in the given document.');

          case 10:
            // TODO: consider in-place editing to optimize
            // shallow copy proofs and add SECURITY_CONTEXT_URL
            proofSet = proofSet.map(function (proof) {
              return _objectSpread({
                '@context': constants.SECURITY_CONTEXT_URL
              }, proof);
            });
            return _context3.abrupt("return", {
              proofSet: proofSet,
              document: document
            });

          case 12:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _getProofs2.apply(this, arguments);
}

function _verify(_x4) {
  return _verify3.apply(this, arguments);
} // add a `toJSON` method to an error which allows for errors in validation
// reports to be serialized properly by `JSON.stringify`.


function _verify3() {
  _verify3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref5) {
    var document, suites, proofSet, purpose, documentLoader, expansionMap, compactProof, result, matches;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            document = _ref5.document, suites = _ref5.suites, proofSet = _ref5.proofSet, purpose = _ref5.purpose, documentLoader = _ref5.documentLoader, expansionMap = _ref5.expansionMap, compactProof = _ref5.compactProof;
            _context5.next = 3;
            return Promise.all(proofSet.map(function (proof) {
              return purpose.match(proof, {
                document: document,
                documentLoader: documentLoader,
                expansionMap: expansionMap
              });
            }));

          case 3:
            result = _context5.sent;
            matches = proofSet.filter(function (value, index) {
              return result[index];
            });

            if (!(matches.length === 0)) {
              _context5.next = 7;
              break;
            }

            return _context5.abrupt("return", []);

          case 7:
            _context5.next = 9;
            return Promise.all(matches.map( /*#__PURE__*/function () {
              var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(proof) {
                var _iterator, _step, s;

                return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                  while (1) {
                    switch (_context4.prev = _context4.next) {
                      case 0:
                        _iterator = _createForOfIteratorHelper(suites);
                        _context4.prev = 1;

                        _iterator.s();

                      case 3:
                        if ((_step = _iterator.n()).done) {
                          _context4.next = 11;
                          break;
                        }

                        s = _step.value;
                        _context4.next = 7;
                        return s.matchProof({
                          proof: proof,
                          document: document,
                          documentLoader: documentLoader,
                          expansionMap: expansionMap
                        });

                      case 7:
                        if (!_context4.sent) {
                          _context4.next = 9;
                          break;
                        }

                        return _context4.abrupt("return", s.verifyProof({
                          proof: proof,
                          document: document,
                          purpose: purpose,
                          documentLoader: documentLoader,
                          expansionMap: expansionMap,
                          compactProof: compactProof
                        }).catch(function (error) {
                          return {
                            verified: false,
                            error: error
                          };
                        }));

                      case 9:
                        _context4.next = 3;
                        break;

                      case 11:
                        _context4.next = 16;
                        break;

                      case 13:
                        _context4.prev = 13;
                        _context4.t0 = _context4["catch"](1);

                        _iterator.e(_context4.t0);

                      case 16:
                        _context4.prev = 16;

                        _iterator.f();

                        return _context4.finish(16);

                      case 19:
                      case "end":
                        return _context4.stop();
                    }
                  }
                }, _callee4, null, [[1, 13, 16, 19]]);
              }));

              return function (_x6) {
                return _ref7.apply(this, arguments);
              };
            }()));

          case 9:
            return _context5.abrupt("return", _context5.sent.map(function (r, i) {
              if (!r) {
                return null;
              }

              if (r.error) {
                _addToJSON(r.error);
              }

              return _objectSpread({
                proof: matches[i]
              }, r);
            }).filter(function (r) {
              return r;
            }));

          case 10:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _verify3.apply(this, arguments);
}

function _addToJSON(error) {
  Object.defineProperty(error, 'toJSON', {
    value: function value() {
      return serializeError(this);
    },
    configurable: true,
    writable: true
  });
}

function _getTypeInfo(_x5) {
  return _getTypeInfo2.apply(this, arguments);
}

function _getTypeInfo2() {
  _getTypeInfo2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref6) {
    var document, documentLoader, expansionMap, ctx, compacted, alias, toExpand, expanded;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            document = _ref6.document, documentLoader = _ref6.documentLoader, expansionMap = _ref6.expansionMap;
            // determine `@type` alias, if any
            ctx = jsonld.getValues(document, '@context');
            _context6.next = 4;
            return jsonld.compact({
              '@type': '_:b0'
            }, ctx, {
              documentLoader: documentLoader,
              expansionMap: expansionMap
            });

          case 4:
            compacted = _context6.sent;
            delete compacted['@context'];
            alias = Object.keys(compacted)[0]; // optimize: expand only `@type` and `type` values

            toExpand = {
              '@context': ctx
            };
            toExpand['@type'] = jsonld.getValues(document, '@type').concat(jsonld.getValues(document, alias));
            _context6.next = 11;
            return jsonld.expand(toExpand, {
              documentLoader: documentLoader,
              expansionMap: expansionMap
            });

          case 11:
            _context6.t0 = _context6.sent[0];

            if (_context6.t0) {
              _context6.next = 14;
              break;
            }

            _context6.t0 = {};

          case 14:
            expanded = _context6.t0;
            return _context6.abrupt("return", {
              types: jsonld.getValues(expanded, '@type'),
              alias: alias
            });

          case 16:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _getTypeInfo2.apply(this, arguments);
}